import { useState } from "react";
import { Alert, Button, Container, Form, Modal, Spinner } from "react-bootstrap";

const IcoEnvelope = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor"
    className="bi bi-envelope-arrow-up" viewBox="0 0 16 16">
    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4.5a.5.5 0 0 1-1 0V5.383l-7 4.2-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-1.99zm1 7.105 4.708-2.897L1 5.383zM1 4v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1" />
    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.354 1.25 1.25a.5.5 0 0 1-.708.708L13 12.207V14a.5.5 0 0 1-1 0v-1.717l-.28.305a.5.5 0 0 1-.737-.676l1.149-1.25a.5.5 0 0 1 .722-.016" />
  </svg>
);

const IcoLinkedin = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor"
    className="bi bi-linkedin" viewBox="0 0 16 16">
    <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
  </svg>
);

const IcoDiscord = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor"
    className="bi bi-discord" viewBox="0 0 16 16">
    <path d="M13.545 2.907a13.2 13.2 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.2 12.2 0 0 0-3.658 0 8 8 0 0 0-.412-.833.05.05 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.04.04 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032q.003.022.021.037a13.3 13.3 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019q.463-.63.818-1.329a.05.05 0 0 0-.01-.059l-.018-.011a9 9 0 0 1-1.248-.595.05.05 0 0 1-.02-.066l.015-.019q.127-.095.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.05.05 0 0 1 .053.007q.121.1.248.195a.05.05 0 0 1-.004.085 8 8 0 0 1-1.249.594.05.05 0 0 0-.03.03.05.05 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.2 13.2 0 0 0 4.001-2.02.05.05 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.03.03 0 0 0-.02-.019m-8.198 7.307c-.789 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612m5.316 0c-.788 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612" />
  </svg>
);

function Contato() {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleClose = () => {
    setShow(false);
    setStatus("idle");
    setFormData({ name: "", email: "", message: "" });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      setStatus(response.ok ? "success" : "error");
    } catch {
      setStatus("error");
    }
  };

  return (
    <Container className="mb-5">
      <h1>CONTATO</h1>
      <hr />
      <h3>Você pode me contactar de várias formas.</h3>
      <p>
        Deixo abaixo três formas de contato.<br />
        Quanto ao e-mail, ele é o mais tradicional, mas para evitar spam, eu optei por um sistema de validação. Ou seja, quando você preenche o formulário e clica em enviar, um link de validação é enviado para o seu e-mail. Você precisa clicar nesse link para que a mensagem seja entregue para mim. O link expira em 24 horas.<br />
      </p>
      <Button onClick={() => setShow(true)} className="fs-5 btn-danger me-3 mt-5">
        <IcoEnvelope />{" "}Email
      </Button>
      <Button
        as="a"
        href="https://www.linkedin.com/in/rodrigo-vianna-173320249?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BpKisBYL9RiSA3NcHf0trFA%3D%3D"
        className="fs-5 btn-primary ms-3 mt-5"
        target="_blank"
      >
        <IcoLinkedin />{" "}LinkedIn
      </Button>
      <Button as="a" href="https://discord.gg/M4PpAZtbjn" className="fs-5 btn-info ms-3 mt-5" target="_blank">
        <IcoDiscord />{" "}Discord
      </Button>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Enviar mensagem</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {status === "success" ? (
            <Alert variant="success">
              <Alert.Heading>Verifique seu e-mail!</Alert.Heading>
              <p className="mb-0">
                Enviamos um link de validação para <strong>{formData.email}</strong>.
                Clique nele para que sua mensagem seja enviada. O link expira em 24 horas.
              </p>
            </Alert>
          ) : (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Nome</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  maxLength={100}
                  placeholder="Seu nome"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>E-mail de contato</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  maxLength={254}
                  placeholder="seu@email.com"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Mensagem</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  maxLength={5000}
                  placeholder="Escreva sua mensagem..."
                />
              </Form.Group>
              {status === "error" && (
                <Alert variant="danger">
                  Erro ao enviar. Tente novamente.
                </Alert>
              )}
              <Button type="submit" variant="danger" disabled={status === "sending"}>
                {status === "sending" ? (
                  <><Spinner size="sm" className="me-2" />Enviando...</>
                ) : (
                  "Enviar"
                )}
              </Button>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
}
export default Contato;
